import { useEffect } from 'react';

const DEFAULT_TITLE = document.title;

/** Troca o <title> da aba enquanto o componente estiver montado; restaura o padrão ao desmontar. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}
